import UploadModal from './UploadModal.component';

export default UploadModal;
